import {
  GeneralCellRenderer,
  MultiLineCellRenderer,
  NumberCellRenderer,
  RtkActionsCellRenderer,
  CustomerLinkCellRenderer
} from 'components/Grids/CellRenderers';

export default class RtkColumnDefinitions {
  static createColDefs(showUserColumn, permissions) {
    const columnDefs = [
      {
        headerName: 'RtK Reference',
        cellClass: 'center-aligned middle-aligned',
        field: 'referenceCode',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 80,
        width: 100,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Customer ID',
        cellClass: 'center-aligned middle-aligned',
        field: 'customerId',
        cellRendererFramework: CustomerLinkCellRenderer,
        cellRendererParams: { permissions },
        minWidth: 150,
        width: 170,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Tax Residency',
        cellClass: 'center-aligned middle-aligned',
        field: 'taxResidency',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 80,
        width: 100,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'US Citizenship',
        cellClass: 'center-aligned middle-aligned',
        field: 'hasUSCitizenship',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 80,
        width: 100,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Chapter 4 Status',
        cellClass: 'center-aligned middle-aligned',
        field: 'fatcaStatusDescription',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 120,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'RtK Event Description',
        cellClass: 'middle-aligned',
        field: 'changesDescription',
        cellRendererFramework: MultiLineCellRenderer,
        minWidth: 200,
        width: 200,
        sortable: false,
        filter: false,
        autoHeight: true
      },
      {
        headerName: 'Days Since RtK',
        cellClass: 'center-aligned middle-aligned',
        field: 'daysSinceRaised',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 80,
        width: 100,
        filter: false,
      },
      {
        headerName: 'Workflow Status',
        cellClass: 'center-aligned middle-aligned',
        field: 'workflowStageDescription',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 120,
        width: 120,
        filterParams: { apply: true }
      },
      {
        headerName: 'User ID',
        cellClass: 'center-aligned middle-aligned',
        field: 'workflowUsername',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 120,
        filterParams: { apply: true },
        sortable: false,
      },
      {
        headerName: 'View',
        headerClass: 'overflow-auto',
        cellClass: 'center-aligned overflow-hidden form-action-btns',
        field: 'id',
        cellRendererFramework: RtkActionsCellRenderer,
        minWidth: 90,
        width: 100,
        filter: false,
        autoHeight: true,
        suppressSizeToFit: true
      }
    ];

    // remove the user column if it's not being shown
    if (!showUserColumn) {
      columnDefs.splice(columnDefs.indexOf(columnDefs.filter(x => x.field === 'workflowUsername')[0]), 1);
    }
    return columnDefs;
  }
}
